import React from 'react'
import "../../styles/commoncomponents/assetInfoWarning.scss";

function GroupWarning(props) {
  return (
    <React.Fragment>
      <div className="groupWarning-head">
        {props.warningTextHead ? <p>{props.warningTextHead} </p> : <p>Please select an asset to generate this report </p>}

      </div>
      <div className="groupWarning-body">
        {props.warningTextBody ? <p>{props.warningTextBody} </p> : <p>Please select an asset to generate this report </p>}
      </div>
    </React.Fragment>
  )
}

export default GroupWarning

